module.exports = __webpack_public_path__ + "static/media/yellow-p.079e46ec.svg";